import { Props_SnippetLinksContent } from './LinksContent.props'
import { CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'

type LinksContentItem = Props_SnippetLinksContent['repeatable_link'][number]

const isValidLink = (link: LinksContentItem) => {
    const label = link.label?.value?.trim()
    const href = link.href?.value?.trim()
    return Boolean(label && href)
}

const SnippetLinksContent = (props: Props_SnippetLinksContent) => {
    const { title, paragraph, linksContentBackground, repeatable_link } = props

    const titleContent = title.content?.value?.trim()
    const paragraphContent = paragraph.text?.value?.trim()
    const visibleLinks = repeatable_link.filter(isValidLink)
    const backgroundTheme = linksContentBackground?.color?.value
    const backgroundColorStyle = backgroundTheme ? `snippet-links-content--${backgroundTheme}` : ''

    return (
        <section className={`snippet-links-content ${backgroundColorStyle}`}>
            <div className="snippet-links-content__container">
                {title.visibility?.value && titleContent && (
                    <div className="snippet-links-content__title">
                        {CompileMarkdown(titleContent)}
                    </div>
                )}

                {paragraphContent && (
                    <div className="snippet-links-content__paragraph">
                        {CompileMarkdown(paragraphContent)}
                    </div>
                )}

                {visibleLinks.length > 0 && (
                    <nav className="snippet-links-content__links" aria-label="Links content navigation">
                        <ul className="snippet-links-content__list">
                            {visibleLinks.map((link, index) => {
                                const label = link.label.value!.trim()
                                const href = link.href.value!.trim()
                                const openInNewWindow = Boolean(link.openInNewWindow?.value)

                                return (
                                    <li key={`links-content-link-${index}`} className="snippet-links-content__item">
                                        <a
                                            className="snippet-links-content__link"
                                            href={href}
                                            target={openInNewWindow ? '_blank' : '_self'}
                                            rel={openInNewWindow ? 'noopener noreferrer' : undefined}
                                        >
                                            {label}
                                        </a>
                                    </li>
                                )
                            })}
                        </ul>
                    </nav>
                )}
            </div>
        </section>
    )
}

export default SnippetLinksContent
